export default "__VITE_ASSET__BnVBzaH5__"